import { createSelector } from '@reduxjs/toolkit';
import { ThemeSlice } from './Theme.slice';

const selectThemeSlice = (state: any): ThemeSlice => state.theme;

export const themeSelectType = createSelector(
  selectThemeSlice,
  (state): string => state.type,
);
